import React, { useContext, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// Custom Components
import DynamicDialog from '@/ui/Dialog/DynamicDialog';
import DialogToolbarHeading from '@/ui/Dialog/DialogToolbarHeading';
import DialogToolbarButtonClose from '@/ui/Dialog/ToolbarButtons/DialogToolbarButtonClose';
import ToolbarFillContent from '@/ui/Toolbar/ToolbarFillContent';
import DialogActionButtonClose from '@/ui/Dialog/ActionButtons/DialogActionButtonClose';
import DialogContext, { IDialogProps } from '@/context/DialogContext/DialogContext';
import ModelTable from '@/ui/Table/ModelTable';

// Types

const PPVKupoprodajniUgovoriDialog: FunctionComponent<IDialogProps> = (props) => {
  const { hideDialog } = useContext(DialogContext);
  const { t } = useTranslation();

  const { recordsUgovori, dcUgovori } = props;

  const handleClose = () => {
    close();
    // { dataChanged: false, action: "cancel" }
  };

  const close = () => {
    hideDialog();
  };

  return (
    <DynamicDialog open maxWidth='xl' onClose={handleClose}>
      <DialogTitle>
        <Toolbar variant="dense" disableGutters>
          <DialogToolbarHeading>{t('cjenovni_blokovi.ugovori')}</DialogToolbarHeading>
          <ToolbarFillContent />
          <DialogToolbarButtonClose onClick={handleClose} />
        </Toolbar>
      </DialogTitle>
      <DialogContent>
        <Box height="650px">
          <ModelTable
            title=" "
            tableName="ugovori"
            viewName="default"
            records={recordsUgovori || []}
            dc={dcUgovori}
            allowSelection="none"
            allowAdd={false}
            allowRowAction={() => false}
            onRowAction={() => { }}
            disableControls={false}
            allowColumnPicker
            size="small"
            allowFilter
            allowExport
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <DialogActionButtonClose variant="outlined" onClick={handleClose} />
      </DialogActions>
    </DynamicDialog>
  );
};

export default PPVKupoprodajniUgovoriDialog;
